module.exports = __webpack_public_path__ + "media/landing_page/location-9298ba5c.svg";